import { type InsuranceCorporateIdentity } from "../types";

export function TuiBkkLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M449 135.947C449 144.951 445.423 153.586 439.056 159.952C432.689 166.318 424.053 169.895 415.048 169.895C406.044 169.895 397.408 166.318 391.041 159.952C384.673 153.586 381.096 144.951 381.096 135.947C381.096 126.944 384.673 118.309 391.041 111.943C397.408 105.577 406.044 102 415.048 102C424.053 102 432.689 105.577 439.056 111.943C445.423 118.309 449 126.944 449 135.947ZM82.175 187.778H173.781C182.827 187.778 189.523 190.715 192.166 203.372C195.103 217.556 193.987 227.423 177.951 228.539L149.169 230.595C170.374 364.212 294.023 407.795 361.365 263.808C372.526 239.992 376.05 235.646 388.356 238.67C404.891 242.781 407.153 251.356 399.223 275.29C341.099 452.772 145.441 470.581 107.057 233.619L83.7659 235.293C64.7635 236.644 64.0004 220.61 64.0004 211.799C63.9417 194.091 70.4911 187.778 82.1799 187.778L82.175 187.778Z"
        fill="#D40E14"
      />
    </svg>
  );
}

export const TuiBkk: InsuranceCorporateIdentity = {
  id: "tui-bkk",
  name: "TUI BKK",
  logo: TuiBkkLogo,
  backgroundColor: "#61C5E9",
  textColor: "#FFFFFF",
  wildcard: "tui",
  type: "statutory",
};
